var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    fill: "#10384F",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96 48C96 74.5097 74.5097 96 48 96C21.4903 96 0 74.5097 0 48C0 21.4903 21.4903 0 48 0C74.5097 0 96 21.4903 96 48ZM7.2 48C7.2 70.5332 25.4668 88.8 48 88.8C70.5332 88.8 88.8 70.5332 88.8 48C88.8 25.4668 70.5332 7.2 48 7.2C25.4668 7.2 7.2 25.4668 7.2 48Z",
    fillOpacity: 0.12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96 48C96 39.5742 93.7821 31.2969 89.5692 24C85.3563 16.7031 79.2969 10.6437 72 6.43078L68.4 12.6662C74.6024 16.2471 79.7529 21.3976 83.3338 27.6C86.9148 33.8024 88.8 40.8381 88.8 48H96Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.bc74f309a6c0b3dce0879ee6e2c686c2.svg";
export { ForwardRef as ReactComponent };